import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Download, Play, Trash2, WifiOff, CheckCircle } from 'lucide-react';

const DownloadManager = () => {
  const [downloads, setDownloads] = useState([]);

  const handleDownload = (movie) => {
    const newDownload = {
      id: Date.now(),
      movie,
      progress: 0,
      status: 'downloading',
      size: '1.2 GB',
      quality: '1080p'
    };

    setDownloads(prev => [newDownload, ...prev]);

    // Simular descarga
    const interval = setInterval(() => {
      setDownloads(prev => prev.map(dl => 
        dl.id === newDownload.id 
          ? { ...dl, progress: Math.min(dl.progress + 10, 100) }
          : dl
      ));
    }, 500);

    setTimeout(() => {
      clearInterval(interval);
      setDownloads(prev => prev.map(dl => 
        dl.id === newDownload.id 
          ? { ...dl, status: 'completed', progress: 100 }
          : dl
      ));
    }, 5000);
  };

  const handleDelete = (downloadId) => {
    setDownloads(prev => prev.filter(dl => dl.id !== downloadId));
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-white mb-6">Mis Descargas</h2>
      
      {downloads.length === 0 ? (
        <div className="text-center py-12">
          <WifiOff className="w-16 h-16 text-gray-600 mx-auto mb-4" />
          <h3 className="text-xl font-semibold text-white mb-2">No hay descargas</h3>
          <p className="text-gray-400">Las películas que descargues aparecerán aquí para ver sin conexión</p>
        </div>
      ) : (
        <div className="grid gap-4">
          {downloads.map(download => (
            <motion.div
              key={download.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="flex items-center gap-4 p-4 bg-gray-800/50 rounded-lg border border-gray-700/50"
            >
              <img
                src={download.movie.image}
                alt={download.movie.title}
                className="w-16 h-20 object-cover rounded"
              />
              
              <div className="flex-1">
                <h3 className="text-white font-semibold">{download.movie.title}</h3>
                <div className="flex items-center gap-4 text-gray-400 text-sm mt-1">
                  <span>{download.quality}</span>
                  <span>•</span>
                  <span>{download.size}</span>
                  <span>•</span>
                  <span className={`
                    ${download.status === 'completed' ? 'text-green-400' : 
                      download.status === 'downloading' ? 'text-yellow-400' : 'text-red-400'}
                  `}>
                    {download.status === 'completed' ? 'Completado' : 
                     download.status === 'downloading' ? 'Descargando' : 'Error'}
                  </span>
                </div>
                
                {download.status === 'downloading' && (
                  <div className="w-full bg-gray-700 rounded-full h-2 mt-2">
                    <div 
                      className="bg-yellow-500 h-2 rounded-full transition-all duration-300"
                      style={{ width: `${download.progress}%` }}
                    />
                  </div>
                )}
              </div>

              <div className="flex gap-2">
                {download.status === 'completed' && (
                  <motion.button
                    className="p-2 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors"
                    whileHover={{ scale: 1.1 }}
                  >
                    <Play className="w-4 h-4" />
                  </motion.button>
                )}
                <motion.button
                  onClick={() => handleDelete(download.id)}
                  className="p-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors"
                  whileHover={{ scale: 1.1 }}
                >
                  <Trash2 className="w-4 h-4" />
                </motion.button>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DownloadManager;